import { Content } from "./types";
import { red } from "@material-ui/core/colors";


const homePageUrl = process.env.PUBLIC_URL;
const localUrl = process.env.LOCAL_URL;
const content: Content = {
  idApplication: "5f47bb310de82dbadd8a89e8",
  footer: [
    {
      link: "https://www.p-w-p.fr/",
      type: "link",
      text: "©PWP",
    },
    {
      type: "content",
      content: `<p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style="font-size: 19px; font-family: MontserratRegular, serif; color: rgb(0, 0, 0);">Mentions l&eacute;gales</span></strong></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Editeur</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Le site &laquo; PWP SECURE &raquo;, accessible &agrave; l&rsquo;adresse www.pwpsecure.fr est &eacute;dit&eacute; par PWP Agence : experts en spiritueux, et d&eacute;velopp&eacute; par Upandgo, agence sp&eacute;cialis&eacute;e en digital learning.</span></span></p>
      
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Contacts :</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Agence PWP&nbsp;</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">15-19 Quai Gallieni 92150, Suresnes</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">&nbsp;</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">H&eacute;bergeur</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Ce site est h&eacute;berg&eacute; par OVH</span></span></p>
      
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">&nbsp;</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Donn&eacute;es personnelles&nbsp;</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Nous sommes attach&eacute;s &agrave; la protection de vos donn&eacute;es personnelles. La pr&eacute;sente politique a pour objectif de vous expliquer comment vos donn&eacute;es sont collect&eacute;es et trait&eacute;es au travers du site www.pwpsecure.fr. Nous vous recommandons de prendre connaissance de la pr&eacute;sente politique de donn&eacute;es personnelles afin de bien comprendre nos engagements et vos droits concernant vos donn&eacute;es personnelles.&nbsp;</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Pour toutes questions ou informations relatives &agrave; la pr&eacute;sente politique de donn&eacute;es personnelles, merci d&rsquo;&eacute;crire &agrave; :&nbsp;</span><a href="mailto:dpo@p-w-p.fr"><span style='font-size:13px;font-family:"MontserratRegular",serif;'>dpo@p-w-p.fr</span></a><span style="font-size: 13px; font-family: MontserratRegular, serif;">&nbsp;. Les donn&eacute;es &agrave; caract&egrave;re personnel collect&eacute;es au travers du site www.pwpsecure.fr (le &laquo; Site &raquo;) sont trait&eacute;es par les organisations &eacute;ditrices du site. D&eacute;l&eacute;gu&eacute;e &agrave; la protection des donn&eacute;es : <span style="font-family: MontserratRegular, serif; font-size: 13px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-style: initial; text-decoration-color: initial; float: none; display: inline !important;">M. Franck PENARD</span>&nbsp;</span></span></p>
      
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Finalit&eacute;s du traitement des donn&eacute;es collect&eacute;es par le Site :</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Vos donn&eacute;es pourront &ecirc;tre collect&eacute;es et trait&eacute;es &agrave; des fins :</span></span></p>
      <ul style="list-style-type: disc;margin-left:0cmundefined;">
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">D&rsquo;identification des personnes ayant suivi le parcours de formation&nbsp;</span></span></li>
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">D&rsquo;&eacute;dition d&rsquo;un certificat simplifi&eacute; pour les apprenants qui valident le parcours de formation&nbsp;</span></span></li>
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">De prise de contact, y compris par email, pour r&eacute;pondre &agrave; vos commentaires ou demandes d&rsquo;informations, ou pour vous joindre en cas de besoin lors du traitement ou de l&rsquo;envoi de services offerts sur le Site.</span></span></li>
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 13px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-style: initial; text-decoration-color: initial; float: none; display: inline !important;">De vérification de la majorité de l'apprenant, cette formation étant à destination d’animations et service de boissons alcoolisées.</span>
      
      <br>
          </span></li>
      </ul>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Destinataires de vos donn&eacute;es</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Les destinataires de vos donn&eacute;es personnelles sont :</span></span></p>
      <ul style="list-style-type: disc;margin-left:0cmundefined;">
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">Les personnes habilit&eacute;es au sein de l&rsquo;agence PWP, &eacute;ditrice du site, qui sont en charge du traitement de vos donn&eacute;es. Celles-ci n&rsquo;ont acc&egrave;s qu&rsquo;aux seules donn&eacute;es qui leur sont n&eacute;cessaires dans le cadre de leurs fonctions.</span></span></li>
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">Nos sous-traitants en charge de la gestion, pour le compte de l&rsquo;agence &eacute;ditrice du site, de vos donn&eacute;es, notamment pour l&rsquo;h&eacute;bergement du Site, la maintenance applicative.</span></span></li>
      </ul>
      
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Dur&eacute;e de conservation de vos donn&eacute;es</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Vos donn&eacute;es sont conserv&eacute;es pour la dur&eacute;e d&rsquo;utilisation de votre compte jusqu&rsquo;&agrave; ce que vous le supprimiez ou que celui-ci soit consid&eacute;r&eacute; comme inactif (au bout de 3 ans d&rsquo;inutilisation). Nous pouvons &ecirc;tre amen&eacute;s &agrave; conserver vos donn&eacute;es pour une dur&eacute;e sup&eacute;rieure &agrave; celle pr&eacute;cis&eacute;e ci-dessus en application d&rsquo;une loi ou d&rsquo;un r&egrave;glement.</span></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Vos droits et recours</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Vous disposez d&rsquo;un droit d&rsquo;acc&egrave;s &agrave; vos donn&eacute;es, de rectification et d&rsquo;effacement de vos donn&eacute;es personnelles. Vous b&eacute;n&eacute;ficiez &eacute;galement d&rsquo;un droit de limitation du traitement, d&rsquo;un droit &agrave; la portabilit&eacute; et d&rsquo;un droit d&rsquo;opposition conform&eacute;ment &agrave; la l&eacute;gislation fran&ccedil;aise et europ&eacute;enne en vigueur relative &agrave; la protection des donn&eacute;es &agrave; caract&egrave;re personnel, notamment la loi fran&ccedil;aise n&deg; 78-17 du 6 janvier 1978 modifi&eacute;e, dite loi Informatique et Libert&eacute;s, et le r&egrave;glement g&eacute;n&eacute;ral relatif &agrave; la protection des donn&eacute;es 2016/679, dit RGPD.<br> Vous disposez &eacute;galement du droit de d&eacute;finir vos directives relatives &agrave; la conservation, &agrave; l&rsquo;effacement et &agrave; la communication de vos donn&eacute;es personnelles apr&egrave;s votre d&eacute;c&egrave;s conform&eacute;ment &agrave; l&rsquo;article 40-1 de la Loi Informatique et Libert&eacute;s.<br> Nous ferons le n&eacute;cessaire pour r&eacute;pondre de mani&egrave;re satisfaisante &agrave; vos demandes. Si, pour quelle que raison que ce soit, vous consid&eacute;rez que notre r&eacute;ponse n&rsquo;est pas satisfaisante, nous vous informons que vous pouvez introduire une r&eacute;clamation aupr&egrave;s de la CNIL.<br>&nbsp;Vous disposez de la possibilit&eacute; de retirer votre consentement au traitement de vos donn&eacute;es aux fins de prospection, et ce &agrave; tout moment :</span></span></p>
      
      <ul style="list-style-type: disc;margin-left:0cmundefined;">
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">Par le biais d&rsquo;un lien de d&eacute;sabonnement au sein des emails que vous recevez ;</span></span></li>
        <li><span style="color: rgb(0, 0, 0);"><span style="font-family: MontserratRegular, serif; font-size: 9.5pt;">En nous contactant &agrave; l&rsquo;adresse ci-dessous.</span></span></li>
      </ul>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; font-family: MontserratRegular, serif;">Nous contacter</span></strong></span></p>
      <p style='margin-top:0cm;margin-right:0cm;margin-bottom:6.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style="color: rgb(0, 0, 0);"><span style="font-size: 13px; font-family: MontserratRegular, serif;">Pour toutes questions et demandes d&rsquo;informations concernant la pr&eacute;sente politique de donn&eacute;es personnelles, ou pour exercer l&rsquo;un quelconque de vos droits mentionn&eacute;s ci-dessus, vous pouvez contacter le responsable de traitement des donn&eacute;es par mail &agrave;&nbsp;</span><a href="mailto:dpo@p-w-p.fr"><span style='font-size:13px;font-family:"MontserratRegular",serif;'>dpo@p-w-p.fr</span></a></span><span style="font-size: 13px; font-family: MontserratRegular, serif; color: rgb(0, 0, 0);">&nbsp;ou par courrier postal &agrave; l&rsquo;adresse suivante : Agence PWP - 15-19 Quai Gallieni 92150, Suresnes</span></p>
      `,
      text: "Mentions légales /  RGPD",
    },
  ],
  branding: {
    logo: homePageUrl + "/img/customer_logo.png",
    title: "PROTOCOLE SANITAIRE",
    subtitle: "10 min pour adopter les nouveaux réflexes qui protègent et rassurent !",
    mainIllustration: homePageUrl + "/img/landing/illustration.png",
    header: homePageUrl + "/img/header.png",
    background: homePageUrl + "/img/landing/background.png",
  },
  intro:
    "Pour l’animation de dégustations de boissons alcoolisées, le respect d’un protocole précis et de règles d’hygiène strictes est désormais devenu incontournable. Ce module micro-learning vous permet de découvrir et maitriser le protocole PWP.",
  totalTime: "10 MIN",
  sections: [
    {
      id: "je-me-forme",
      index: 1,
      title: "Je me forme",
      description: "",
      image: homePageUrl + "/img/Icon material-ondemand-video.svg",
      type: "video",
      duration: "4 min",
      video: {
        url: homePageUrl + "/videos/PWP_motion_VF.mp4",
        subtitle: homePageUrl + "/videos/PWP_motion_v4.vtt",
      },
    },

    {
      id: "quiz-validant",
      index: 2,
      title: "Quiz validant",
      description: "",
      image: homePageUrl + "/img/interrogation_minipanel.png",
      type: "finalQuiz",
      threshold: 8,
      certificate: {
        password:"pwpsecure",
        backgroundImage: homePageUrl + "/img/background.jpg",
        companyLogo: homePageUrl + "/img/logo_pwp_agence_black.png",
        formationLogo: homePageUrl + "/img/logo_pwp_secure_black.png",
        pastilleCertif: homePageUrl + "/img/medaille.png",
        formationName: "LE PROTOCOLE SANITAIRE",
        primaryColor: "#363636",
        secondaryColor: "#CDBD64",
      },
      shouldSendDataTo: "https://register-stats-server.upandgo.fr/user-scorm",
      quiz: {
        id: "quiz-final",
        questionList: [
          {
            id: "q1",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title: "Question 1",
              description: "Je me rends compte la veille de l’animation que je suis fiévreux et que je commence à tousser.",
              media: {
                type: "image",
                url: homePageUrl + "/img/illus_quiz/Illus-quiz_1.png",
              },
            },
            answerList: [
              {
                id: "a1-1",
                text:
                  "Je prends du paracétamol pour faire baisser la fièvre et du sirop pour la toux. J’assure l’animation en faisant attention à bien tousser dans mon masque.",
                valid: false,
              },
              {
                id: "a1-2",
                text: "J'appelle mon médecin. Il me faut d'urgence un certificat médical.",
                valid: false,
              },
              {
                id: "a1-3",
                text: "J'appelle tout de suite mon référent à l'agence pour faire le point sur la situation.",
                valid: true,
              },
            ],
          },
          {
            id: "q2",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 2",
              description:"Le personnel de l’établissement ne respecte pas les gestes barrières et me reproche « d’en faire trop »",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_2.png",
                },
            },
            answerList: [
              {
                id: "a2-1",
                text:
                  "Ça n’est pas mon problème ni ma responsabilité. Je continue de mon côté à appliquer strictement mon protocole sanitaire.",
                valid: true,
              },
              {
                id: "a2-2",
                text:
                  "Je leur demande de respecter les gestes barrières. Il faut qu’ils soient plus sérieux car il en va de notre sécurité à tous !",
                valid: false,
              },
              {
                id: "a2-3",
                text:
                  "Je donne un peu moins de visibilité à mon protocole. J’ai besoin d’une bonne fluidité avec le personnel de l’établissement pour réussir mon animation.",
                valid: false,
              },
            ],
          },
          {
            id: "q3",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 3",
              description:"Les consommateurs ne respectent pas les gestes barrières et boivent par exemple dans le même verre de dégustation.",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_3.png",
                },
            },
            answerList: [
              {
                id: "a3-1",
                text:
                  "Je les encourage à respecter les gestes élémentaires et leur propose du gel hydro alcoolique. Je n’oublie pas que le sourire se ressent à travers le masque.",
                valid: true,
              },
              {
                id: "a3-2",
                text:
                  "Je leur signale que leur comportement n’est pas adapté. L’animation ne pourra pas se poursuivre s’ils continuent à prendre des risques.",
                valid: false,
              },
              {
                id: "a3-3",
                text:
                  "Je continue mon animation en me protégeant mais je laisse tomber la désinfection du plateau et l’espacement des verres: ça ne sert plus à rien.",
                valid: false,
              },
            ],
          },
          {
            id: "q4",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 4",
              description:"Il n’y a pas suffisamment de place dans l’établissement pour isoler mon espace de préparation.",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_4.png",
                },
            },
            answerList: [
              {
                id: "a4-1",
                text:
                  "J’improvise en utilisant une table ou des chaises en guise de barrières pour créer de la distance. Bref je fais au mieux afin que personne ne touche l’espace de préparation.",
                valid: true,
              },
              {
                id: "a4-2",
                text:
                  "Je ne prends aucun risque. Pas d’animation possible dans ces conditions.",
                valid: false,
              },
              {
                id: "a4-3",
                text:
                  "Tant pis pour l’espace de préparation. Mais je me lave bien les mains et continue à porter mon masque.",
                valid: false,
              },
            ],
          },
          {
            id: "q5",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 5",
              description:"Les consommateurs ou le personnel ne portent pas systématiquement un masque lorsqu’ils circulent dans l’établissement et s’approchent de moi.",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_5.png",
                },
            },
            answerList: [
              {
                id: "a5-1",
                text:
                  "Ca les regarde et je ne peux rien y faire.",
                valid: false,
              },
              {
                id: "a5-2",
                text:
                  "Ca les regarde. Moi, en tout cas je porte un masque en permanence et je demande avec le sourire (mais fermement) que toute personne s’approchant de moi à moins d’un mètre mette son masque.",
                valid: true,
              },
              {
                id: "a5-3",
                text:
                  "Je retire mon masque pour faire comme tout le monde.",
                valid: false,
              },
            ],
          },
          {
            id: "q6",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 6",
              description:"La règle des « un mètre de distance » est impossible à respecter dans l’établissement faute d’espace.",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_6.png",
                },
            },
            answerList: [
              {
                id: "a6-1",
                text:
                  "Je ne prends aucun risque. Pas d’animation possible dans ces conditions.",
                valid: false,
              },
              {
                id: "a6-2",
                text:
                  "J'appelle tout de suite mon référent à l'agence pour faire le point sur la situation.",
                valid: true,
              },
              {
                id: "a6-3",
                text:
                  "Je garde mon masque pour me protéger mais pour le reste je ne peux rien faire.",
                valid: false,
              },
            ],
          },
          {
            id: "q7",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 7",
              description:"Je désinfecte mon espace de préparation...",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_7.png",
                },
            },
            answerList: [
              {
                id: "a7-1",
                text:
                  "En arrivant et avant de repartir.",
                valid: false,
              },
              {
                id: "a7-2",
                text:
                  "Avant chaque phase de dégustation et au minimum toutes les 30 minutes.",
                valid: true,
              },
              {
                id: "a7-3",
                text:
                  "De temps en temps, quand j’ai un moment.",
                valid: false,
              },
            ],
          },
          {
            id: "q8",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 8",
              description:"Je me lave les mains...",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_8.png",
                },
            },
            answerList: [
              {
                id: "a8-1",
                text:
                  "De temps en temps, quand j’ai un moment.",
                valid: false,
              },
              {
                id: "a8-2",
                text:
                  "En arrivant dans l’établissement.",
                valid: false,
              },
              {
                id: "a8-3",
                text:
                  "Avant chaque phase d’activité et au minimum toutes les 30 minutes.",
                valid: true,
              },
            ],
          },
          {
            id: "q9",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 9",
              description:"L’établissement n’a pas de poubelle à pédale.",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_9.png",
                },
            },
            answerList: [
              {
                id: "a9-1",
                text:
                  "J’utilise une poubelle ouverte ou même un carton. L’essentiel est de ne pas avoir à toucher la poubelle avec les mains à chaque utilisation.",
                valid: true,
              },
              {
                id: "a9-2",
                text:
                  "J’utilise une poubelle normale. L’essentiel est qu’il y ait un couvercle pour éviter que le virus ne sorte.",
                valid: false,
              },
              {
                id: "a9-3",
                text:
                  "Je ne prends aucun risque. Pas d’animation possible dans ces conditions.",
                valid: false,
              },
            ],
          },
          {
            id: "q10",
            type: "singleAnswer",
            showEachAnswerResults: true,
            question: "",
            instructions: "Cliquez sur la bonne réponse.",
            context: {
              title:"Question 10",
              description:"Il y a des éléments manquants ou en quantité insuffisante dans le matériel qui m’a été fourni (masques, gel, spray désinfectant, gobelets...) ",
                media: {
                  type: "image",
                  url: homePageUrl + "/img/illus_quiz/Illus-quiz_10.png",
                },
            },
            answerList: [
              {
                id: "a10-1",
                text:
                  "Je fais au mieux avec le matériel dont je dispose. Ce n’est pas de ma faute s’il en manque.",
                valid: false,
              },
              {
                id: "a10-2",
                text:
                  "Je ne prends aucun risque. Pas d’animation possible dans ces conditions.",
                valid: false,
              },
              {
                id: "a10-3",
                text:
                  "Je demande au personnel de l’établissement s’il peut me dépanner. Si ça n’est pas possible, je vais acheter moi-même le matériel manquant à l’extérieur en gardant la facture.",
                valid: true,
              },
            ],
          },
        ],
      },
    },
    {
      id: "fiche-memo",
      index: 3,
      title: "Fiche Memo",
      description: "",
      image: homePageUrl + "",
      type: "resources",
      resources :  [
        { 
        id: "fiche-memo-pdf",
        title: "Téléchargez ici",
        description: "",
        url: homePageUrl + "/img/PWP-fiche-memo_VF.pdf",
      },
    ]
    },
  ],
  saveBookmark: false,
  canResetBookmark: false,
  credits: [""],
};

export default content;
